"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDevLoggerWithPrefix = void 0;
var createDevLoggerWithPrefix = exports.createDevLoggerWithPrefix = function createDevLoggerWithPrefix(prefix) {
  var isDev = process.env.REACT_APP_NODE_ENV === "development";
  var createLogMethod = function createLogMethod(type) {
    if (!isDev) return function () {};
    var consoleMethod = console[type];
    var prefixMsg = "[".concat(prefix, " ").concat(type.toUpperCase(), "]:");
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return consoleMethod.apply(void 0, [prefixMsg].concat(args));
    };
  };
  return {
    log: createLogMethod("log"),
    error: createLogMethod("error"),
    warn: createLogMethod("warn"),
    info: createLogMethod("info"),
    debug: createLogMethod("debug")
  };
};